import styled from "styled-components";
import { theme } from "../theme";

export const StyledCalendar = styled.div`
	margin-top: 3rem;

	& .fc-col-header-cell-cushion {
		color: rgb(15, 15, 15);
		font-family: ${theme.font.secondary};
	}

	& .fc-daygrid-day-number {
		color: rgb(15, 15, 15);
		font-family: ${theme.font.secondary};
	}

	& .fc-daygrid-day-top {
		justify-content: center;
	}

	& .fc-today-button {
		display: none;
	}

	& .fc-button-primary {
		background-color: transparent !important;
		border-color: transparent !important;
		color: rgb(15, 15, 15) !important;
	}

	& .fc-toolbar-chunk {
		width: 100%;

		&:nth-child(2) {
			display: none;
		}

		&:nth-child(3) {
			position: absolute;
			top: 50%;
			left: 50%;

			transform: translate(-50%, -50%);
		}
	}

	& .fc-header-toolbar {
		position: relative;
	}

	& .fc-toolbar-title {
		margin: 0 auto;
		text-align: center;

		display: block;
	}

	& .fc-button-group {
		margin-left: 0 !important;
		width: 100%;

		display: flex;
		justify-content: space-between;

		& .fc-button {
			border: none !important;
			outline: none !important;
			box-shadow: none !important;

			max-width: 5rem;
		}
	}

	& .fc-event {
		/* padding: 0.5rem; */
		margin-bottom: 0.5rem;

		background-color: transparent;
		border: none;
		/* box-shadow: 0 0 3px ${theme.color.green}; */

		& span {
			max-width: 100%;

			display: block;
			overflow: hidden;

			color: rgb(15, 15, 15);
			font-size: 1.2rem;
			font-weight: 300;
			text-overflow: ellipsis;
		}
	}

	& .fc-daygrid-day.fc-day-today {
		background-color: rgba(51, 175, 137, 0.35);
	}

	& .fc-daygrid-day-frame {
		height: 100px;
	}

	& .fc-event-main > div {
		padding: 0.3rem 0.5rem;

		display: flex;
		align-items: center;

		border-radius: 0.3rem;

		&.draft {
			border: 1px dashed ${theme.color.gray2};
			background-color: ${theme.color.white};
		}

		&.ongoing {
			border: 1px solid ${theme.color.orange};
			background-color: #fcf8cf;
		}

		&.done {
			border: 1px solid ${theme.color.green};
			background-color: #cffcee;
		}

		&.archive {
			border: 1px solid ${theme.color.blue2};
			background-color: #d7dde5;
		}
	}
`;

export const StyledCalendarFilters = styled.div`
	margin-left: 5rem;

	display: flex;
	flex-direction: column;
	row-gap: 3rem;

	& h3 {
		margin-bottom: 1rem;
		position: relative;

		cursor: pointer;

		&::selection, & * {
			background-color: transparent;
		}
		
		& i {
			position: absolute;
			top: 50%;
			left: -2.5rem;
			
			transition: all .3s ease-out;
			transform: translateY(-50%) rotate(-90deg);

			& img::selection, & * {
			background-color: transparent;
		}
		}
	}

	& > div > div {
		max-height: 0;
		overflow-y: hidden;
		overflow-x: visible;

		transition: max-height .3s ease-out;
	}

	& div.active > div {
		max-height: 38rem;
	}
	
	& div.active h3 i {
		transform: translateY(-50%) rotate(0);
	}

	& .statusFilters {
		& label {
			width: min-content;
			position: relative;

			&::selection {
				background-color: transparent;
			}

			&::after {
				height: .9rem;
				width: .9rem;

				content: "";
				display: block;
				position: absolute;
				top: 50%;
				right: -1.5rem;

				border-radius: 10rem;

				transform: translateY(-50%);
			}

			&:nth-child(1)::after {
				background-color: ${theme.color.orange};
			}

			&:nth-child(2)::after {
				background-color: ${theme.color.green};
			}

			&:nth-child(3)::after {
				background-color: ${theme.color.blue2};
			}
		}
	}

	& label {
		margin-bottom: .5rem;
		font-size: 1.2rem;

		text-transform: capitalize;

		display: flex;
		align-items: center;

		cursor: pointer;

		& > div {
			margin-right: .5rem;
		}
	}

	& 
`;
